<template>
    <div class="quick-declare-query-side-panel">
        <div class="section header">
            <div class="data-block">
                <!-- <div class="label">申報所屬年月份</div> -->
                <div class="data" style="font-size: 15pt;">{{ declarePeriodText }}</div>
            </div>
            <!-- <div class="data-block">
                <div class="label">稅籍編號</div>
                <div class="data">{{ taX_BOO }}</div>
            </div> -->
        </div>
        <div class="section">
            <div class="data-block title">
                <div class="title-label">應稅銷項</div>
                <div class="title-data">{{ declaredInvoiceItems.length }} 張</div>
            </div>
            <div class="data-block">
                <div class="label">應稅銷售總計</div>
                <div class="data"><Money :v="invoiceAmt - invoiceTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">銷項稅額</div>
                <div class="data"><Money :v="invoiceTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">- 銷項折讓總計</div>
                <div class="data"><Money :v="invoiceDiscountAmt - invoiceDiscountTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">- 銷項折讓稅額</div>
                <div class="data"><Money :v="invoiceDiscountTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">作廢張數</div>
                <div class="data">{{ invoiceVoidCount }} 張</div>
            </div>
        </div>
        <div class="section">
            <div class="data-block title">
                <div class="title-label">得扣抵進項</div>
                <div class="title-data">{{ declaredPaymentItems.length }} 張</div>
            </div>
            <div class="data-block">
                <div class="label">可扣抵進項金額</div>
                <div class="data"><Money :v="paymentAmt - paymentTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">進項稅額</div>
                <div class="data"><Money :v="paymentTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">- 進項折讓總計</div>
                <div class="data"><Money :v="paymentDiscountAmt - paymentDiscountTaxAmt" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">- 進項折讓稅額</div>
                <div class="data"><Money :v="paymentDiscountTaxAmt" /> 元</div>
            </div>
            <div v-if="nonPayedPaymentLength > 0" class="data-block">
                <div class="warning-msg">提醒：有待付款的進項發票 {{ nonPayedPaymentLength }} 張</div>
            </div>
        </div>
        <div class="section no-bottom">
            <div class="data-block title">
                <div class="title-label">計算稅額合計</div>
                <div class="title-data">{{ declaredItems.length }} 張</div>
            </div>
            <div class="data-block">
                <div class="label">
                    <span>本期應繳稅額 <ah-tip>（銷項稅額 － 銷項折讓稅額）－（進項稅額 － 進項折讓稅額）</ah-tip></span>
                </div>
                <div class="data"><Money :v="toBePayed" /> 元</div>
            </div>
            <div class="data-block">
                <div class="label">
                    <span>本期留抵稅額 <ah-tip>"進項稅額"大於"銷項稅額"時：本期進項－本期銷項</ah-tip></span>
                </div>
                <div class="data"><Money :v="couldBeDiscount" /> 元</div>
            </div>
            <!-- <div class="hint">*上期留抵金額請於財政部電子申報軟體自行登載</div> -->
            <!-- <div class="hint" @click="onOpenHing">*上期留抵金額請於財政部電子申報軟體自行登載</div> -->
        </div>

        <div>
            <slot />
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    components: {},
    data() {
        return {
            period: null,
            queryTimeType: 1,
            queryType: 1, // 1 發票收入(銷項) 2 請款支出(進項)
            status: 'undeclared',
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapState({
            declaredItems: (state) => [...state.businessTax.declaredPaymentItems, ...state.businessTax.declaredInvoiceItems],
            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,

            //
            invoiceAmt: (state) => {
                console.log(_.filter((x) => !(x.code === 33 || x.code === '33')));
                return _.chain(state.businessTax.declaredInvoiceItems)
                    .filter((x) => !(x.code === 33 || x.code === '33'))
                    .sumBy('amt')
                    .value();
            },
            invoiceDiscountAmt: (state) => _.chain(state.businessTax.declaredInvoiceItems)
                .filter((x) => x.code === 33 || x.code === '33')
                .sumBy('amt')
                .value(),
            invoiceTaxAmt: (state) => _.chain(state.businessTax.declaredInvoiceItems)
                .filter((x) => !(x.code === 33 || x.code === '33'))
                .sumBy('amT_TAX')
                .value(),
            invoiceDiscountTaxAmt: (state) => _.chain(state.businessTax.declaredInvoiceItems)
                .filter((x) => x.code === 33 || x.code === '33')
                .sumBy('amT_TAX')
                .value(),
            invoiceVoidCount: (state) => _.filter(state.businessTax.declaredInvoiceItems, ['foO_CNL', 1]).length,

            paymentAmt: (state) => _.chain(state.businessTax.declaredPaymentItems)
                .filter((x) => !(x.code === 23 || x.code === '23'))
                .sumBy('amt')
                .value(),
            paymentDiscountAmt: (state) => _.chain(state.businessTax.declaredPaymentItems)
                .filter((x) => x.code === 23 || x.code === '23')
                .sumBy('amt')
                .value(),
            paymentTaxAmt: (state) => _.chain(state.businessTax.declaredPaymentItems)
                .filter((x) => !(x.code === 23 || x.code === '23'))
                .sumBy('tax')
                .value(),
            paymentDiscountTaxAmt: (state) => _.chain(state.businessTax.declaredPaymentItems)
                .filter((x) => x.code === 23 || x.code === '23')
                .sumBy('tax')
                .value(),

            //
            queryParams: (state) => state.businessTax.queryParams,
            taxDeclareStatus: (state) => state.businessTax.TaxDeclareStatus,
            periodList: (state) => state.businessTax.periodList,
            storePeriod: (state) => state.businessTax.period,
            dataCount: (state) => state.businessTax.dataCount,
            declarePeriodText: (state) => {
                const PERIOD_OBJECT = _.find(state.businessTax.periodList, {
                    year: state.businessTax.declarePeriodYear,
                    value: state.businessTax.declarePeriod,
                });
                return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '--';
            },

            taX_BOO: (state) => state.menu.companyInfo.taX_BOO,
        }),
        nonPayedPaymentLength() {
            return _.filter(this.declaredPaymentItems, (o) => o.sigN_STS === 5).length;
        },

        toBePayed() {
            const RETURN = this.invoiceTaxAmt - this.invoiceDiscountTaxAmt - (this.paymentTaxAmt - this.paymentDiscountTaxAmt);
            return RETURN > 0 ? RETURN : 0;
        },
        couldBeDiscount() {
            const RETURN = this.paymentTaxAmt - this.paymentDiscountTaxAmt - (this.invoiceTaxAmt - this.invoiceDiscountTaxAmt);
            return RETURN > 0 ? RETURN : 0;
        },
    },
    methods: {
        ...mapMutations({
            updateQuery: 'businessTax/updateQuery',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        init() {
            this.period = this.storePeriod;
            this.queryTimeType = this.queryParams.SearchType;
            this.queryType = this.queryParams.QueryType;
            this.status = this.taxDeclareStatus;
        },
        onQueryTypeChange() {
            // 校正status選項
            if (this.queryType === 1) {
                if (this.status === 'not-declare') this.status = 'zero-tax';
                else if (this.status === 'invalid') this.status = 'no-need-declare';
            } else if (this.queryType === 2) {
                if (this.status === 'zero-tax') this.status = 'not-declare';
                else if (this.status === 'no-need-declare') this.status = 'invalid';
            }
        },
        onNextStep() {
            this.$router.push({ name: 'accounting-business-tax-quick-declare-step-3' });
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
.quick-declare-query-side-panel {
    padding: 40px;

    .section {
        // border-bottom: 1px solid #bfbfe6;
        padding: 16px 0px;

        &:first-child {
            padding-top: 0;
        }
        &:last-child {
            padding-bottom: 0;
        }
        &.header {
            font-weight: bold;
            padding: 0 0 15px 0;
        }
        &.no-bottom {
            border-bottom: 0;
            padding-bottom: 0;
        }
        >.title {
            border-bottom: 1px solid #000;
            padding: 5px 0;
            color: #000;
            .title-label {
                font-weight: bold;
            }
            .title-data {
            }
        }

        .data-block {
            display: flex;
            justify-content: space-between;
            font-size: 10pt;
            line-height: 190%;
            &.title {
                margin-bottom: 7px;
            }
        }
        .label {
            color: #555555;
            font-weight: 400;
        }
        .data {
            .money {
                font-weight: normal;
            }
            // font-weight: bold;
            &.large {
                .money {
                    font-weight: bold;
                    font-size: 15pt;
                }
            }
        }
        .hint {
            color: #828282;
            font-size: 10px;
            font-weight: 400;
            margin-top: 5px;
            // cursor: pointer;
            // text-decoration: underline;
        }
        .warning-msg {
            font-size: 9pt;
            color: #FF7F00;
        }
    }
    .btn {
        margin-top: 10px;
        width: 100%;
    }
    .btn-normal {
        margin-top: 10px;
        margin-left: 0;
        width: 100%;
    }

    .status-selection-section {
        display: flex;
        flex-direction: column;
        .el-radio {
            margin-bottom: 20px;
        }
        .description {
            color: #000;
            margin-left: 25px;
            font-size: 8pt;
        }
    }
}
</style>
